// COLORS
export const TEXT_COLOR = '#61DAFB';
export const BACKGROUND_COLOR = '#282C34';
export const DARK_HIGHLIGHT = '#191920';
export const HOVER = '#2D3343';
export const BLACK = '#000';
// SIZES
export const NAVBAR_HEIGHT = 50;
export const MIN_WIDTH = 1100;
